import Vue from "vue";
import lightVueTree from "light-vue-tree";

// style
import "light-vue-tree/lib/style/index.css";

Vue.component("VueTree", lightVueTree);
